//for internatiionaliztion

export const getCurrencySymbol = (ISO)=>(
	(0).toLocaleString(
		navigator.language,
		{
			style: 'currency',
			currency: ISO || 'USD',
			minimumFractionDigits: 0,
			maximumFractionDigits: 0
		}
	).replace(/\d/g, '').trim()
)